window.callYTPlayer = function (func, frame_id, args) {

    //if its a jquery object, extrapolate the element
    if (frame_id && window.jQuery && frame_id instanceof jQuery) {
        frame_id = frame_id.get(0);
    }

    if (!frame_id || frame_id === undefined) {
        console.debug("acting on all players");

        var iframes = document.getElementsByTagName('iframe');

        for (var i = 0; i < iframes.length; ++i) {
            if (iframes[i]) {
                var src = iframes[i].getAttribute('src');
                if (src) {
                    if (src.indexOf('youtube.com/embed') != -1) {
                        iframes[i].contentWindow.postMessage(JSON.stringify({
                            'event': 'command',
                            'func': func,
                            'args': args || []
                        }), "*");
                    }
                }
            }
        }
    }
    else if (typeof frame_id === 'string') {
        var iframe = document.getElementById(frame_id);

        iframe.contentWindow.postMessage(JSON.stringify({
            'event': 'command',
            'func': func,
            'args': args || [],
            "id": frame_id
        }), "*");
    }
    //if its an iframe object, assign directly
    else if (typeof frame_id === 'object' && frame_id.tagName !== undefined && frame_id.tagName.toUpperCase() === 'IFRAME') {
        frame_id.contentWindow.postMessage(JSON.stringify({
            'event': 'command',
            'func': func,
            'args': args || [],
        }), "*");
    }
}

//we have modals that need to stop playing when the modal is closed
//modals can either already exist with youtube videos, which are then hooked into and have their play/stop commands called
//or we can create the iframe on modal open, and replace the iframe with a div containing the original ID on close

//window.ytplayerList;
//window.videoHeadingPlayer2;
//var videoHeadingPlayer;

//function initYoutubePlayers() {
//    window.ytplayerList = null; //reset
//    window.ytplayerList = []; //create new array to hold youtube player
//    $('iframe').each(function (e) {
//        if (/youtube.com\/embed/.test($(this).attr('src'))) {
//            ytplayerList.push(initYoutubePlayer($(this)[0]));
//            console.log("create a Youtube player successfully");
//        }
//    });
//}

////init a youtube iframe
//function initYoutubePlayer(ytiframe) {

//    console.log("have youtube iframe");
//    var ytp = new YT.Player(ytiframe, {

//    });

//    ytiframe.ytp = ytp;
//    return ytp;
//}

//window.InitExistingPlayers = function () {
//    console.log("video heading hooking existing iframe");

//    videoHeadingPlayer = new YT.Player('videoHeadingIframe', {
//        height: '390',
//        width: '640',
//        videoId: 'nmvE81lygyA',
//        playerVars: {
//            'playsinline': 1
//        }
//    });

//    console.log("hooked existing iframe");
//    console.log(videoHeadingPlayer);
//}

//// 2. This code loads the IFrame Player API code asynchronously.
////var tag = document.createElement('script');

////tag.src = "https://www.youtube.com/iframe_api";
////var firstScriptTag = document.getElementsByTagName('script')[0];
////firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

//// 3. This function creates an <iframe> (and YouTube player)
////    after the API code downloads.
//var player;

//window.onYouTubeIframeAPIReady = function () {
//    console.log("loaded within main.js");

//    //InitExistingPlayers();

//    //initYoutubePlayers();

//    //player = new YT.Player('player', {
//    //    height: '390',
//    //    width: '640',
//    //    videoId: 'M7lc1UVf-VE',
//    //    playerVars: {
//    //        'playsinline': 1
//    //    },
//    //    events: {
//    //        'onReady': onPlayerReady,
//    //        'onStateChange': onPlayerStateChange
//    //    }
//    //});
//}

//// 4. The API will call this function when the video player is ready.
//function onPlayerReady(event) {
//    console.log("onPlayerReady");
//    event.target.playVideo();
//}

//// 5. The API calls this function when the player's state changes.
////    The function indicates that when playing a video (state=1),
////    the player should play for six seconds and then stop.
//var done = false;
//function onPlayerStateChange(event) {
//    console.log("onPlayerStateChange");
//    if (event.data == YT.PlayerState.PLAYING && !done) {
//        setTimeout(stopVideo, 10000);
//        done = true;
//    }
//}
//function stopVideo() {
//    console.log("stopping");
//    player.stopVideo();
//}

//function stopVideos() {
//    console.log("stopping");
//    player.stopVideo();
//}

//window.createPlayer = function (videoId) {
//    console.log("video heading creating player");

//    videoHeadingPlayer = new YT.Player('videoHeadingModal', {
//        videoId: videoId,
//        playerVars: {
//            'autoplay': 1
//        },
//        events: {
//            'onReady': onPlayerReady
//        }
//    });

//    console.log("video heading created player");
//    console.log(videoHeadingPlayer);
//}

/**
 * @author       Rob W <gwnRob@gmail.com>
 * @website      https://stackoverflow.com/a/7513356/938089
 * @version      20190409
 * @description  Executes function on a framed YouTube video (see website link)
 *               For a full list of possible functions, see:
 *               https://developers.google.com/youtube/js_api_reference
 * @param String frame_id The iframe, the id of iframe, or of the element containing the frame
 * @param String func     Desired function to call, eg. "playVideo"
 *        (Function)      Function to call when the player is ready.
 * @param Array  args     (optional) List of arguments to pass to function func*/
//window.callPlayer = function (frame_id, func, args) {

//    console.debug("callPlayer called");

//    var iframe;

//    if (window.jQuery && frame_id instanceof jQuery) frame_id = frame_id.get(0).id;

//    if (typeof frame_id == 'string') {
//        //get iframe directly by id
//        iframe = document.getElementById(frame_id);

//        //if its still null, get the first iframe child of the element
//        if (iframe && iframe.tagName.toUpperCase() != 'IFRAME') {
//            iframe = iframe.getElementsByTagName('iframe')[0];
//        }
//    }
//    //if its an iframe object, assign directly
//    else if (typeof frame_id == 'object' && frame_id.tagName !== undefined && frame_id.tagName.toUpperCase() == 'IFRAME') {
//        iframe = frame_id;
//    }

//    // When the player is not ready yet, add the event to a queue
//    // Each frame_id is associated with an own queue.
//    // Each queue has three possible states:
//    //  undefined = uninitialised / array = queue / .ready=true = ready
//    if (!callPlayer.queue) callPlayer.queue = {};
//    var queue = callPlayer.queue[frame_id],
//        domReady = document.readyState == 'complete';

//    if (domReady && !iframe) {
//        // DOM is ready and iframe does not exist. Log a message
//        window.console && console.log('callPlayer: Frame not found; id=' + frame_id);
//        if (queue) clearInterval(queue.poller);
//    } else if (func === 'listening') {
//        // Sending the "listener" message to the frame, to request status updates
//        if (iframe && iframe.contentWindow) {
//            func = '{"event":"listening","id":' + JSON.stringify('' + frame_id) + '}';
//            iframe.contentWindow.postMessage(func, '*');
//        }
//    } else if ((!queue || !queue.ready) && (
//        !domReady ||
//        iframe && !iframe.contentWindow ||
//        typeof func === 'function')) {
//        if (!queue) queue = callPlayer.queue[frame_id] = [];
//        queue.push([func, args]);
//        if (!('poller' in queue)) {
//            // keep polling until the document and frame is ready
//            queue.poller = setInterval(function () {
//                callPlayer(frame_id, 'listening');
//            }, 250);
//            // Add a global "message" event listener, to catch status updates:
//            messageEvent(1, function runOnceReady(e) {
//                if (!iframe) {
//                    iframe = document.getElementById(frame_id);
//                    if (!iframe) return;
//                    if (iframe.tagName.toUpperCase() != 'IFRAME') {
//                        iframe = iframe.getElementsByTagName('iframe')[0];
//                        if (!iframe) return;
//                    }
//                }
//                if (e.source === iframe.contentWindow) {
//                    // Assume that the player is ready if we receive a
//                    // message from the iframe
//                    clearInterval(queue.poller);
//                    queue.ready = true;
//                    messageEvent(0, runOnceReady);
//                    // .. and release the queue:
//                    while (tmp = queue.shift()) {
//                        callPlayer(frame_id, tmp[0], tmp[1]);
//                    }
//                }
//            }, false);
//        }
//    } else if (iframe && iframe.contentWindow) {
//        // When a function is supplied, just call it (like "onYouTubePlayerReady")
//        if (func.call) return func();
//        // Frame exists, send message
//        iframe.contentWindow.postMessage(JSON.stringify({
//            "event": "command",
//            "func": func,
//            "args": args || [],
//            "id": frame_id
//        }), "*");
//    }
//    /* IE8 does not support addEventListener... */
//    function messageEvent(add, listener) {
//        var w3 = add ? window.addEventListener : window.removeEventListener;
//        w3 ?
//            w3('message', listener, !1)
//            :
//            (add ? window.attachEvent : window.detachEvent)('onmessage', listener);
//    }
//}